const buildQueryParams = (params: any) => {

  const queryParamArray = Object.keys(params)

    .filter(key => params[key] !== undefined && params[key] !== null)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);

  return queryParamArray.length ? `?${queryParamArray.join('&')}` : '';
}

export default buildQueryParams